/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useFloating, flip, offset } from '@floating-ui/react-dom';
import * as S from './DotMenu.styled';
import { DotMenuIcon } from 'assets/icons';
import { isAdvertiserRole, isAdminSelector } from 'store/selectors';
import { menuItems, menuActions } from 'constants';
import { convertMenuItems, getDynamicUrl, redirectToOldPlatformUrl } from 'utils';
import { manageAppsAPI } from 'services/manageApps.service';
import { routes } from 'config';

const DotMenu = ({ pba_id, is_deleted, isRedirect$ }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const { x, y, strategy, refs } = useFloating({
    middleware: [flip(), offset(10)],
    placement: 'bottom-end',
    strategy: 'fixed',
  });
  const isAdvertiser = useSelector(isAdvertiserRole);
  const isAdmin = useSelector(isAdminSelector);
  const currentMenuItems = convertMenuItems(menuItems, !isAdvertiser, is_deleted, isAdmin).filter(
    (item) => {
      if (item.id in menuActions) return item;
    },
  );

  const [restoreAppAction] = manageAppsAPI.useRestoreAppMutation();
  const [deleteAppAction] = manageAppsAPI.useDeleteAppMutation();

  const handleItemClick = (id) => {
    // if (id === menuActions.app_settings) {
    //   let url = getDynamicUrl(
    //     routes.list.find((route) => route.id === 'manageApps/appSettings/generalSettings').url,
    //     {
    //       pba_id,
    //     },
    //   );
    //   navigate(url);
    // }
    if (id === menuActions.restore) {
      restoreAppAction(pba_id);
    }
    if (id === menuActions.archive) {
      deleteAppAction(pba_id);
    }
    if (id === menuActions.promote_this_app) {
      let url = routes.list.find((route) => route.id === 'campaign/newCampaign_empty').url;
      url = `${url}?app=${pba_id}`;
      navigate(url);
      //console.log('REACT_APP_ENV', window.REACT_APP_ENV);
      // if (window.REACT_APP_ENV === 'production') {
      //   //isRedirect$.value = true;
      //   const newUrl = redirectToOldPlatformUrl(`/Discovery/Campaign.aspx?app=${pba_id}`);
      //   console.log(newUrl);
      //   //window.location.assign(newUrl);
      //   // window.location.href = newUrl;
      // }
      // if (window.REACT_APP_ENV === 'qa') {
      //   console.log(menuActions.promote_this_app);
      //   //new campaign and select it app
      // }
    }
    setIsOpen(false);
  };

  const linkHandleClick = (e) => {
    if (window.REACT_APP_ENV === 'qa') {
      console.log(menuActions.promote_this_app);
      e.preventDefault();
      //new campaign and select it app
    }
    const newUrl = redirectToOldPlatformUrl(`/Discovery/Campaign.aspx?app=${pba_id}`);
    console.log({ redirectTo: newUrl, env: window.REACT_APP_ENV });
  };

  const getHrefForLink = (menuName) => {
    if (menuName === 'app_settings') {
      let url = getDynamicUrl(
        routes.list.find((route) => route.id === 'manageApps/appSettings/generalSettings').url,
        {
          pba_id,
        },
      );
      return url;
    }
    if (menuName === 'promote_this_app') {
      const href = `${
        routes.list.find((route) => route.id === 'campaign/newCampaign_empty').url
      }?app=${pba_id}`;
      return href;
      //return redirectToOldPlatformUrl(`/Discovery/Campaign.aspx?app=${pba_id}`);
    }
  };

  return (
    <>
      {isOpen && <S.Slice onClick={() => setIsOpen(false)} />}

      <S.DotsContainer onClick={() => setIsOpen((isOpen) => !isOpen)} ref={refs.setReference}>
        <S.DotsHeader isOpen={isOpen}>
          <DotMenuIcon />
        </S.DotsHeader>
      </S.DotsContainer>

      <S.ParentContainer>
        {isOpen && (
          <S.DropDownList
            ref={refs.setFloating}
            style={{
              position: strategy,
              top: y ?? 0,
              left: x ?? 0,
              width: 'max-content',
              zIndex: 800001,
            }}
          >
            {currentMenuItems
              .filter((item) => item.show)
              .map((menuItem) => {
                return (
                  <S.ListItem key={menuItem.id} onClick={() => handleItemClick(menuItem.id)}>
                    {menuItem.type === 'div' ? (
                      <>
                        <span>{menuItem.icon}</span>
                        <span>{menuItem.name}</span>
                      </>
                    ) : (
                      <S.MyLink to={getHrefForLink(menuItem.id)}>
                        <span>{menuItem.icon}</span>
                        <span>{menuItem.name}</span>
                      </S.MyLink>
                    )}
                  </S.ListItem>
                );
              })}
          </S.DropDownList>
        )}
      </S.ParentContainer>
    </>
  );
};

DotMenu.propTypes = {
  pba_id: PropTypes.string.isRequired,
};

export default DotMenu;
